import { useRouter } from 'next/router'
import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'

export default function useTravelChatBot() {
  const { pathname } = useRouter()
  const { isMobile, locale } = useBootstrapData()
  const isHomepage = pathname === '/'
  const isGoodToDisplayChatBot =
    locale?.countryCode?.toLowerCase() === 'us' && !isMobile && isHomepage
  const CHATBOT_TYPEAHEAD_POC = useSeti(
    'CHATBOT_TYPEAHEAD_POC',
    isGoodToDisplayChatBot
  )

  const isChatBotBelowButtonPlacement =
    CHATBOT_TYPEAHEAD_POC === 'BELOW_BUTTON_PLACEMENT' && isGoodToDisplayChatBot

  const isChatBotPackagePlacement =
    CHATBOT_TYPEAHEAD_POC === 'PACKAGE_PLACEMENT' && isGoodToDisplayChatBot

  const showChatBot = isChatBotBelowButtonPlacement || isChatBotPackagePlacement
  return {
    showChatBot,
    isChatBotBelowButtonPlacement,
    isChatBotPackagePlacement
  }
}
